import React from 'react';
import { View, Text, TouchableOpacity, ScrollView, StyleSheet } from 'react-native';
import { EVENT_FILTER_LABELS } from '@/types/admin/events';
import { AnchoredDropdown } from '@/components/common/admin/desktop/dropdown/AnchoredDropdown';
import { AnchorRect } from '@/hooks/common/useAnchoredPosition';
import { IEventFilters } from '../types';
import { useAdminColors } from '@/hooks/admin/useAdminColors';

export const FilterDropdown = ({
  anchor,
  filters,
  onToggle,
  onRequestClose,
}: {
  anchor: AnchorRect | null;
  filters: IEventFilters;
  onToggle: (key: string) => void;
  onRequestClose?: () => void;
}) => {
  const { redesign } = useAdminColors();
  return (
    <AnchoredDropdown
      isOpen={!!anchor}
      anchor={anchor}
      width={240}
      maxHeight={320}
      onRequestClose={onRequestClose}
    >
      <ScrollView style={{ maxHeight: 320 }}>
        {EVENT_FILTER_LABELS.map((label) => (
          <TouchableOpacity
            key={label.key}
            style={styles.row}
            onPress={() => onToggle(label.key)}
            activeOpacity={0.7}
          >
            <View
              style={[
                styles.checkbox,
                {
                  borderColor: redesign.card.border,
                  backgroundColor: redesign.glass.buttonBg,
                },
                filters[label.key] && {
                  backgroundColor: redesign.accent.blueBg,
                  borderColor: redesign.accent.blueBg,
                },
              ]}
            />
            <Text style={[styles.text, { color: redesign.text.primary }]}>
              {label.title}
            </Text>
          </TouchableOpacity>
        ))}
      </ScrollView>
    </AnchoredDropdown>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    paddingHorizontal: 8,
    borderRadius: 6,
  },
  checkbox: {
    width: 16,
    height: 16,
    borderRadius: 4,
    borderWidth: 1,
    marginRight: 10,
  },
  text: { fontSize: 14 },
});
